import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { authRoutes, routes } from "./pages/index";
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/style.css";

const App = () => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const storedAdmin = localStorage.getItem("adminData");
    if (storedAdmin) {
      setAdmin(JSON.parse(storedAdmin));
    } else {
      setAdmin(null);
    }
  }, []);

  return (
    <Routes>
      {/* ---------- AUTH ROUTES ---------- */}
      {!admin &&
        authRoutes.map((data, index) => (
          <Route key={index} path={data.path} element={data.component} />
        ))}

      {/* ---------- PROTECTED ROUTES ---------- */}
      {admin &&
        routes.map((data, index) => (
          <Route key={index} path={data.path} element={data.component} />
        ))}

      {/* ---------- FALLBACK ---------- */}
      <Route
        path="*"
        element={
          admin ? (
            <Navigate to="/customers" replace />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
    </Routes>
  );
};

export default App;
